/** ColorSwitcher — recolour the mark, by random hue or a rainbow sweep. */
import type { AffectModule } from '../../core/module-api';
import { cfgStr } from '../../core/module-api';
import { cloneShape, hslToRgba } from '../../core/scene';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 0 0 18"/><path d="M12 3a9 9 0 0 1 0 18"/></svg>';

export function createColorSwitcher(): AffectModule {
  return {
    manifest: {
      id: 'colorswitcher',
      kind: 'affect',
      name: 'Color',
      apiVersion: 1,
      description: 'Recolour each mark — random hue or a rolling rainbow.',
      icon: ICON,
      capabilities: ['random'],
      params: [
        {
          kind: 'select',
          key: 'mode',
          label: 'Mode',
          default: 'palette',
          options: [
            { value: 'palette', label: 'Palette' },
            { value: 'random', label: 'Random' },
            { value: 'rainbow', label: 'Rainbow' },
          ],
        },
      ],
    },

    affect(shapes, ctx) {
      const mode = cfgStr(ctx.config, 'mode', 'palette');
      const n = Math.max(1, shapes.length);
      return shapes.map((s, i) => {
        const c = cloneShape(s);
        const a = s.style.color.a; // preserve upstream alpha
        if (mode === 'palette') c.style.color = { ...ctx.palette.at(i), a };
        else if (mode === 'random') c.style.color = { ...ctx.palette.sample(ctx.rng), a };
        else c.style.color = hslToRgba((i / n) * 360, 0.7, 0.5, a); // full spectrum
        return c;
      });
    },
  };
}
